import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';


@Component({
  tag: 'metric-card',
  styleUrl: 'metric-card.css',
  shadow: true,
})
export class MetricCard {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.cards-wrapper'),
      () => {
        this.el.shadowRoot.querySelector('.cards-wrapper').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4'],
    );
  }

  render() {
    const cards = JSON.parse(this.cardsData);
    const count = cards.length;
    //console.log('card', cards);
    return (
      <Host>
        <section class={`${this.backgroundColor}`} style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          <div
            class={` flex flex-col items-center relative container justify-center ${this.textColor} ${this.textOrientation} ${this.paddingBottom} ${this.paddingTop} layout-cards-${cards.length}`}
          >
            <div class={`${this.textOrientation}`}>
              {this.mainTitle && <h3 class={`mb-32px fs-4 text-ui-gray-1`}>{this.mainTitle}</h3>}
              {this.description && <div innerHTML={this.description}></div>}
            </div>
            <div class={` cards-wrapper layout-${count}`}>
              {cards.length > 0 &&
                cards &&
                cards.map((card, index) => (
                  <div
                    class={`card rounded-xl flex flex-col items-center justify-end text-center ${card.background_image[''] ? 'bg-cover bg-center bg-no-repeat' : ''}`}
                    style={{ backgroundImage: `url(${card.background_image ? card.background_image['url'] : ''})` }}
                  >
                    <div class={`overlay${index + 1}`}></div>
                    <div class={`${card.background_color}  card-top `}>
                      <h2 class={`  z-10 relative font-semibold ${this.textColor == 'text-default' ? 'text-white' : this.textColor}`}>{card.title}</h2>
                      <div class={`card-top-overlay m${card.background_color} `}></div>
                    </div>
                    <div class={`card-bottom `}>
                      <p class={` ${this.textColor == 'text-default' ? 'text-ui-gray-2' : this.textColor}`}>{card.description}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
